import { CardComp } from "..";

/**
 * Consistent empty / unavailable states for investor-facing pages.
 */
export function InvestorEmptyState({
  title = "No data yet",
  message = "No data available yet.",
  className = "",
}) {
  return (
    <CardComp cardClassName={`border-0 shadow-sm rounded-4 text-center py-5 px-3 ${className}`}>
      <h2 className="h6 fw-bold mb-2" style={{ color: "#383838" }}>
        {title}
      </h2>
      <p className="text-muted small mb-0 mx-auto" style={{ maxWidth: 420, lineHeight: 1.6 }}>
        {message}
      </p>
    </CardComp>
  );
}

export function InvestorBackendNotConnectedState({
  title = "Not available yet",
  message = "This module is not connected yet. Check back once the backend integration is live.",
  className = "",
}) {
  return (
    <CardComp cardClassName={`border-0 shadow-sm rounded-4 text-center py-5 px-3 ${className}`}>
      <div
        className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle"
        style={{
          width: 64,
          height: 64,
          background: "rgba(49, 119, 140, 0.1)",
          color: "var(--color-secondary)",
        }}
        aria-hidden
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
          <path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        </svg>
      </div>
      <h2 className="h6 fw-bold mb-2" style={{ color: "#383838" }}>
        {title}
      </h2>
      <p className="text-muted small mb-0 mx-auto" style={{ maxWidth: 440, lineHeight: 1.6 }}>
        {message}
      </p>
    </CardComp>
  );
}

export function InvestorApiErrorState({
  message = "We couldn't load this information. Please try again.",
  onRetry,
  className = "",
}) {
  return (
    <CardComp cardClassName={`border-0 shadow-sm rounded-4 text-center py-5 px-3 ${className}`}>
      <p className="text-danger small mb-0 mx-auto" style={{ maxWidth: 420, lineHeight: 1.6 }}>
        {message}
      </p>
      {onRetry ? (
        <button type="button" className="btn btn-link btn-sm mt-2" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </CardComp>
  );
}
